import {
  addDays,
  addWeeks,
  endOfWeek,
  isBefore,
  isToday,
  parseISO,
  startOfDay,
  startOfWeek,
  subWeeks,
} from 'date-fns'
import { endOfDay } from 'date-fns/esm'
import React, { ReactNode } from 'react'
import {
  Button,
  Columns,
  Container,
  Element,
  Heading,
  Icon,
  Level,
  Section,
  Table,
} from 'react-bulma-components'
import Layout from '../../components/layout/layout'
import useStore from '../../store'
import { formatISODate } from '../../utils/date'
import { CalendarIcon, CheckIcon, KpiIcon } from '../../components/icons'
import { useNavigate } from 'react-router-dom'
import { useEmployerStats } from '../../hooks/use-employer-stats'
import { FiltersResourcesEnum, FiltersSlice } from '../../store/filters'
import { EmployerKpis } from '../../components/kpi/employer-kpis'
import { IsoDate } from '../../hooks/use-calendar'
import { DashboardCard } from '../../components/dashboards/dashboard-card'
import { WorkPeriodsFilters } from 'src/components/work-periods/filters'
import useFilters from '../../hooks/filters'

const NewEmployerDashboard: React.FC = () => {
  const currentOrganizationRole = useStore(state => state.session.currentOrganizationRole)
  const { filters, setFilters } = useFilters(FiltersResourcesEnum.workPeriods)
  const navigate = useNavigate()

  const todayStart = startOfDay(new Date())
  const todayEnd = endOfDay(new Date())
  const thisWeekStart = startOfWeek(todayStart)
  const thisWeekEnd = endOfWeek(todayEnd)
  const pastWeekStart = subWeeks(thisWeekStart, 1)
  const pastWeekEnd = subWeeks(thisWeekEnd, 1)
  const pastWeekStartIso = formatISODate(pastWeekStart)
  const pastWeekEndIso = formatISODate(pastWeekEnd)
  const stats = useEmployerStats({ start: pastWeekStartIso, end: pastWeekEndIso })

  return (
    <Layout>
      {currentOrganizationRole === 'clocker' ? (
        <></>
      ) : (
        <Section>
          <Container>
            <Columns gap={8}>
              <Columns.Column>
                <Heading size={3}>Aujourd'hui</Heading>

                <EmployerStat start={formatISODate(todayStart)} end={formatISODate(todayEnd)} />
              </Columns.Column>
              <Columns.Column>
                <Level>
                  <Level.Side>
                    <Heading size={3}>Semaine Passée</Heading>
                  </Level.Side>
                  <Level.Side>
                    <Button
                      color="primary"
                      outlined
                      onClick={() => navigate('/kpi')}
                      textWeight="bold"
                    >
                      <Icon>
                        <KpiIcon />
                      </Icon>
                      <span>Explorer les Statistiques</span>
                    </Button>
                  </Level.Side>
                </Level>

                <EmployerKpis stats={stats} />
              </Columns.Column>
            </Columns>

            <Heading size={3}>Planning</Heading>
            <WorkPeriodsFilters
              display={[
                'interimAgency',
                'employer',
                'jobTitle',
                'service',
                'user',
                'tags',
                'events',
              ]}
            />

            <Planning filters={filters} setFilters={setFilters} />
          </Container>
        </Section>
      )}
    </Layout>
  )
}
export default NewEmployerDashboard

export const Planning = ({
  filters,
  setFilters,
}: {
  filters: { start: IsoDate; end: IsoDate }
  setFilters: FiltersSlice['setFilters']
}): ReactNode => {
  const todayStart = startOfDay(new Date())
  const todayEnd = endOfDay(new Date())
  const thisWeekStart = startOfWeek(todayStart)
  const thisWeekEnd = endOfWeek(todayEnd)
  const pastWeekStart = subWeeks(thisWeekStart, 1)
  const pastWeekEnd = subWeeks(thisWeekEnd, 1)
  const nextWeekStart = addWeeks(thisWeekStart, 1)
  const nextWeekEnd = addWeeks(thisWeekEnd, 1)
  const thisWeek = [0, 1, 2, 3, 4, 5, 6].map(day => ({
    start: formatISODate(addDays(thisWeekStart, day)),
    end: formatISODate(addDays(endOfDay(thisWeekStart), day)),
  }))
  const pastWeek = [0, 1, 2, 3, 4, 5, 6].map(day => ({
    start: formatISODate(addDays(pastWeekStart, day)),
    end: formatISODate(addDays(endOfDay(pastWeekStart), day)),
  }))
  const nextWeek = [0, 1, 2, 3, 4, 5, 6].map(day => ({
    start: formatISODate(addDays(nextWeekStart, day)),
    end: formatISODate(addDays(endOfDay(nextWeekStart), day)),
  }))

  return (
    <Table size="fullwidth">
      <thead>
        <tr>
          <th></th>
          <th>Lundi</th>
          <th>Mardi</th>
          <th>Mercredi</th>
          <th>Jeudi</th>
          <th>Vendredi</th>
          <th>Samedi</th>
          <th>Dimanche</th>
        </tr>
      </thead>
      <tbody>
        <tr
        /* style={{
          backgroundColor:
            filters.start === formatISODate(nextWeekStart) &&
              filters.end === formatISODate(nextWeekEnd)
              ? 'lavender'
              : undefined,
        }} */
        >
          <th>
            Semaine Prochaine
            {/* <br />
            <Button
              size={'small'}
              data-test="see-next-week-button"
              mt={3}
              onClick={() =>
                setFilters({
                  start: formatISODate(nextWeekStart),
                  end: formatISODate(nextWeekEnd),
                })
              }
            >
              Détail
            </Button> */}
          </th>
          {nextWeek.map(({ start, end }) => (
            <td
              key={start}
              style={{
                backgroundColor:
                  filters.start === start && filters.end === end ? 'lavender' : undefined,
              }}
            >
              <PlanningCardItem isoDate={start} />
            </td>
          ))}
        </tr>
        <tr
          style={{
            backgroundColor:
              filters.start === formatISODate(thisWeekStart) &&
              filters.end === formatISODate(thisWeekEnd)
                ? 'lavender'
                : undefined,
          }}
        >
          <th>
            Cette Semaine
            {/* <br />
            <Button
              size={'small'}
              data-test="see-this-week-button"
              mt={3}
              onClick={() =>
                setFilters({
                  start: formatISODate(thisWeekStart),
                  end: formatISODate(thisWeekEnd),
                })
              }
            >
              Détail
            </Button> */}
          </th>
          {thisWeek.map(({ start, end }) => (
            <td
              key={start}
              style={{
                backgroundColor:
                  filters.start === start && filters.end === end ? 'lavender' : undefined,
              }}
            >
              <PlanningCardItem isoDate={start} />
            </td>
          ))}
        </tr>
        <tr
          style={{
            backgroundColor:
              filters.start === formatISODate(pastWeekStart) &&
              filters.end === formatISODate(pastWeekEnd)
                ? 'lavender'
                : undefined,
          }}
        >
          <th>
            Semaine Passée
            {/* <br />
            <Button
              size={'small'}
              data-test="see-previous-week-button"
              mt={3}
              onClick={() =>
                setFilters({
                  start: formatISODate(pastWeekStart),
                  end: formatISODate(pastWeekEnd),
                })
              }
            >
              Détail
            </Button> */}
          </th>
          {pastWeek.map(({ start, end }) => (
            <td
              key={start}
              style={{
                backgroundColor:
                  filters.start === start && filters.end === end ? 'lavender' : undefined,
              }}
            >
              <PlanningCardItem isoDate={start} />
            </td>
          ))}
        </tr>
      </tbody>
    </Table>
  )
}

const PlanningCardItem = ({ isoDate }: { isoDate: IsoDate }): ReactNode => {
  const filters = useStore(s => s.filters[FiltersResourcesEnum.workPeriods])
  const setFilters = useStore(s => s.filters.setFilters)
  const stats = useEmployerStats({ ...filters, start: isoDate, end: isoDate })
  const navigate = useNavigate()
  const date = parseISO(isoDate)
  const isInThePast = isBefore(date, startOfDay(new Date()))
  const isInThePastOrToday = isInThePast || isToday(date)
  const isInTheFuture = !isInThePast
  const isInTheFutureOrToday = isInTheFuture || isToday(date)
  const isPastWeek = isBefore(date, startOfWeek(new Date()))
  const workPeriodsNotValidated = stats.workPeriods.notValidated.length > 0
  const ongoingDemands = stats.posts.combine(stats.posts, ['missing', 'notCancelled']).length > 0
  const displayWorkPeriodsNotValidated = isInThePastOrToday && workPeriodsNotValidated
  const displayOngoingDemands = isInTheFutureOrToday && ongoingDemands
  const allOk = !displayOngoingDemands && !displayWorkPeriodsNotValidated
  const warningColor = isPastWeek ? 'danger-80' : 'warning-80'

  return (
    <>
      <Element renderAs="ul" p={2}>
        <li>{stats.workPeriods.expected.length} Travailleurs</li>
        {allOk ? (
          <>
            <li>
              <Element p={1} mt={1}>
                <Icon.Text>
                  <Icon color="success-70">
                    <CheckIcon />
                  </Icon>
                  OK
                </Icon.Text>
              </Element>
            </li>
            <li>
              <Element p={1} mt={1}>
                &nbsp;
              </Element>
            </li>
          </>
        ) : (
          <>
            <li>
              {displayWorkPeriodsNotValidated ? (
                <Element p={1} mt={1} backgroundColor={warningColor}>
                  {stats.workPeriods.notValidated.length} à Valider !
                </Element>
              ) : (
                <Element p={1} mt={1}>
                  &nbsp;
                </Element>
              )}
            </li>
            <li>
              {displayOngoingDemands ? (
                <Element p={1} mt={1} backgroundColor={warningColor}>
                  {stats.posts.missing.length} Demandes !
                </Element>
              ) : (
                <Element p={1} mt={1}>
                  &nbsp;
                </Element>
              )}
            </li>
          </>
        )}
        <Level mt={3}>
          <Level.Side>
            <Button
              size={'small'}
              onClick={() => {
                setFilters(FiltersResourcesEnum.workPeriods, {
                  ...filters,
                  start: isoDate,
                  end: isoDate,
                })
                navigate('/work-periods')
              }}
            >
              Détail
            </Button>
          </Level.Side>
          <Level.Side>
            {isToday(date) ? (
              <Icon size="small" color={'dark'} data-tooltip="Aujourd'hui">
                <CalendarIcon />
              </Icon>
            ) : null}
          </Level.Side>
        </Level>
      </Element>
    </>
  )
}

const EmployerStat = ({ start, end }: { start: IsoDate; end: IsoDate }): ReactNode => {
  const stats = useEmployerStats({ start, end })

  return (
    <>
      <Columns>
        <Columns.Column size={6}>
          <DashboardCard
            mainStat={{
              value: stats.workPeriods.combine(stats.workPeriods, ['expected']).length,
              label: 'Missions',
            }}
            secondaryStat={
              <>
                + {stats.workPeriods.combine(stats.workPeriods, ['notExpected']).length}{' '}
                interruptions ou abandons
              </>
            }
            queryStatus={'success'}
          />
        </Columns.Column>
        <Columns.Column size={6}>
          <DashboardCard
            mainStat={{
              value: stats.workPeriods.combine(stats.workPeriods, ['expected', 'clockedInNotOut'])
                .length,
              label: 'Présents',
            }}
            secondaryStat={'ont pointé leur entrée'}
            queryStatus={'success'}
          />
        </Columns.Column>
        <Columns.Column size={6}>
          <DashboardCard
            mainStat={{
              value: stats.workPeriods.combine(stats.workPeriods, ['expected', 'late']).length,
              label: 'En retard',
            }}
            secondaryStat={`dont ${
              stats.workPeriods.combine(stats.workPeriods, ['expected', 'late', 'notClocked'])
                .length
            } pas encore arrivés`}
            queryStatus={'success'}
          />
        </Columns.Column>
        <Columns.Column size={6}>
          <DashboardCard
            mainStat={{
              value: stats.workPeriods.combine(stats.workPeriods, ['expected', 'clockedOut'])
                .length,
              label: 'Terminés',
            }}
            secondaryStat={'ont pointé leur sortie'}
            queryStatus={'success'}
          />
        </Columns.Column>
      </Columns>
    </>
  )
}
/* 
export const ValidationProgress = ({
  start,
  end,
  size = 'normal',
}: {
  start: IsoDate
  end: IsoDate
  size?: Size
}): ReactNode => {
  const stats = useEmployerStats(start, end)
  const value = (stats.workPeriods.validated.length / stats.workPeriods.total.length) * 100

  let color: string
  switch (true) {
    case value < 50:
      color = 'danger'
      break
    case value >= 50 && value < 100:
      color = 'warning'
      break
    case value === 100:
      color = 'success'
      break
    default:
      color = 'info'
  }

  return (
    <>
      <ReactTooltip id="validation-progress" backgroundColor={`var(--bulma-${color}-dark)`}>
        <Element textWeight="bold">État de la Validation : {Math.floor(value)}%</Element>
      </ReactTooltip>
      <Element data-tip data-for="validation-progress">
        <Progress size={size} value={value} max={100} color={color} />
      </Element>
    </>
  )
}
 */
